import React from 'react';
import './style.scss';
import { BreadcrumbProps } from './types';

const UQBreadcrumb = (props: BreadcrumbProps) => {
  return (
    <div className='breadcrumbs'>
      {props.crumbs.join(' / ')}
    </div>
  );
};

export default UQBreadcrumb;
